import { useState } from 'react';
import TagFilter from './TagFilter.js';
import data from '../data.js'
const JobListing = () => {

    const [jobs, setJobs] = useState(data);
    const [tags, setTags] = useState([]);

    const handleTagClick = (e) => {
        const tag = e.target.innerText;
        if (tags.includes(tag)) return;
    
        const newTags = [...tags, tag];
        setTags(newTags);
    
        const newJobs = data.filter(job => {
            const jobTags = [job.role, job.level, ...job.languages, ...job.tools];
            return newTags.every(tag => jobTags.includes(tag));
        });
        setJobs(newJobs);
    };

    const handleRemoveTag = (tag) => {
        const updatedTags = tags.filter((t) => t !== tag);
        setTags(updatedTags);
    
        const newJobs = data.filter((job) => {
          const jobTags = [job.role, job.level, ...job.languages, ...job.tools];
          return updatedTags.every((tag) => jobTags.includes(tag));
        });
        setJobs(newJobs);
      };

    const RemoveAllTags = () => {
        setTags([]);
        setJobs(data);    
    };
    
    

    return <>
        <div className="m-7 mt-12 flex flex-col gap-12">
        {tags.length > 0 && <TagFilter tags={tags} handleRemoveTag={handleRemoveTag} RemoveAllTags={RemoveAllTags} />}
            {jobs.map((job) => (
                <div key={job.id} className="rounded-lg border-2 p-2 pl-6 max-[1100px]:pb-8 border-l-desaturated-dark-cyan border-l-4 flex flex-col justify-between gap-6 max-[1100px]:relative shadow-sm shadow-dark-grayish-cyan min-[1100px]:flex-row min-[1100px]:items-center">
                <div className='max-[1100px]:border-b-2 pb-5 border-dark-grayish-cyan min-[1100px]:flex min-[1100px]:justify-center min-[1100px]:items-center min-[1100px]:gap-5'>
                    <img src={process.env.PUBLIC_URL + `images/${job.logo}`} alt='' className='min-[1100px]:self-end w-16 min-[1100px]:w-24 max-[1100px]:absolute max-[1100px]:bottom-[90%] max-[1100px]:left-4' />
                    <div className="flex flex-col gap-3 min-[1100px]:gap-0 justify-start">
                        <div className='flex items-center mt-7 gap-2'>
                            <h3 className='mt-2 mr-10 max-[400px]:mr-0 text-desaturated-dark-cyan font-bold max-[400px]:text-[15px]'>{job.company}</h3>
                            {job.new && <span className='text-base pl-3 pr-3 bg-desaturated-dark-cyan text-light-grayish-cyan-bg rounded-xl max-[400px]:text-[12px]'>NEW!</span>}
                            {job.featured && <span className='text-base pl-3 pr-2 bg-very-dark-grayish-cyan text-light-grayish-cyan-bg rounded-xl max-[400px]:text-[12px]'>FEATURED</span>}
                        </div>
                        <h2 className='font-bold hover:text-dark-grayish-cyan hover:cursor-pointer hover:transition-all duration-500 max-[400px]:text-[18px]'>{job.position}</h2>
                        <div className='text-desaturated-dark-cyan flex gap-10 text-lg max-[400px]:text-[14px]'>
                            <span className=''>{job.postedAt}</span>
                            <span>{job.contract}</span>
                            <span>{job.location}</span>
                        </div>
                    </div>
                </div>
                <div className='flex gap-5 flex-wrap'>
                    <span onClick={handleTagClick} className='hover:bg-desaturated-dark-cyan hover:text-light-grayish-cyan-bg hover:cursor-pointer text-[1.2rem] font-bold bg-light-grayish-cyan-filter text-desaturated-dark-cyan p-1 px-2 rounded-md max-[400px]:text-[15px]'>{job.role}</span>
                    <span onClick={handleTagClick}  className='hover:bg-desaturated-dark-cyan hover:text-light-grayish-cyan-bg hover:cursor-pointer text-[1.2rem] font-bold bg-light-grayish-cyan-filter text-desaturated-dark-cyan p-1 px-2 rounded-md max-[400px]:text-[15px]'>{job.level}</span>
                    {job.languages.map((language,index) => (
                        <span key={index} onClick={handleTagClick}  className='hover:bg-desaturated-dark-cyan hover:text-light-grayish-cyan-bg hover:cursor-pointer text-[1.2rem] font-bold bg-light-grayish-cyan-filter text-desaturated-dark-cyan p-1 px-2 rounded-md max-[400px]:text-[15px]'>{language}</span>
                    ))}
                    {job.tools.map((tool,index) => (
                        <span key={index} onClick={handleTagClick}  className='hover:bg-desaturated-dark-cyan hover:text-light-grayish-cyan-bg hover:cursor-pointer text-[1.2rem] font-bold bg-light-grayish-cyan-filter text-desaturated-dark-cyan p-1 px-2 rounded-md max-[400px]:text-[15px]'>{tool}</span>
                    ))}
                </div>
            </div>
            ))}
        </div>
        </>
}
 
export default JobListing;